export const SET_ACTIVE_NAV_TAB = 'application/SET_ACTIVE_NAV_TAB';

export const setActiveTab = (activeTab) => ({
	type: SET_ACTIVE_NAV_TAB,
	activeTab,
});
